import { defineStore } from 'pinia';

export default defineStore('trueFitStore', () => {
  const lastSelectedSize = ref<number | null>(null);

  return { lastSelectedSize };
});
